import React from 'react';
import { TrendingUpIcon, ZapIcon } from 'lucide-react';
export function CaseStudySection() {
  return <section className="py-12 relative" data-id="element-18">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-19">
        <div className="relative rounded-2xl p-1 bg-gradient-to-b from-cyan-500/30 to-transparent" data-id="element-20">
          <div className="bg-dark-950 rounded-xl p-8 md:p-12 relative overflow-hidden" data-id="element-21">
            {/* Background pattern */}
            <div className="absolute inset-0 opacity-5" style={{
            backgroundImage: 'radial-gradient(#00f0ff 1px, transparent 1px)',
            backgroundSize: '20px 20px'
          }} data-id="element-22"></div>

            <div className="relative z-10" data-id="element-23">
              <div className="flex items-center gap-2 text-cyan-400 font-mono text-sm mb-4" data-id="element-24">
                <ZapIcon className="w-4 h-4" data-id="element-25" />
                <span data-id="element-26">SYSTEM_LOG: SUCCESS_STORY</span>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-white mb-5" data-id="element-27">
                Zero to{' '}
                <span className="text-cyan-400 text-glow" data-id="element-28">$7,500/Month</span> in
                19 Days
              </h2>

              <div className="space-y-6 text-lg text-gray-300" data-id="element-29">
                <p data-id="element-30">
                  One of my students in New York followed this exact stack. He
                  had no coding background. No agency experience.
                </p>

                <div className="flex items-center gap-4 py-4 border-y border-cyan-900/30 my-6" data-id="element-31">
                  <TrendingUpIcon className="w-8 h-8 text-cyan-400" data-id="element-32" />
                  <p className="text-xl font-bold text-white" data-id="element-33">
                    In 19 days, he onboarded 3 clients at $2,500/month each.
                  </p>
                </div>

                <p data-id="element-34">
                  He didn't learn to code. He didn't hire a team. He simply
                  learned to Connect.{' '}
                  <strong className="text-white" data-id="element-35">
                    He became the Architect.
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}